import { z } from "zod";
import { NotificationType } from "../enum.js";

export const NotificationChannel = {
	EMAIL: "email",
	PUSH: "push",
	IN_APP: "in_app",
} as const;
export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel];

export interface NotificationPreference {
	id: string;
	user_id: string;
	type: NotificationType | "*";
	community_id: string | null;
	email_enabled: boolean;
	push_enabled: boolean;
	in_app_enabled: boolean;
	created_at: string;
	updated_at: string;
}

export const updateNotificationPreferenceSchema = z
	.object({
		type: z.union([z.enum(NotificationType), z.literal("*")]),
		community_id: z.uuid().nullable().optional(),
		email_enabled: z.boolean().optional(),
		push_enabled: z.boolean().optional(),
		in_app_enabled: z.boolean().optional(),
	})
	.strict();

export type UpdateNotificationPreferencePayload = z.infer<typeof updateNotificationPreferenceSchema>;
